import DoneIcon from '@material-ui/icons/Done';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import {SubPageProps} from 'cl-layout/BasicPage';
import * as _ from 'lodash';
import * as React from 'react';
import {AmazonListing} from 'cl-api';
import {DISPLAY_TYPES} from 'cl-form/FormSections/consts';
import {MappingType} from '../../shared/components/Dialogs/EditColumnDialogs/EditColumnDialog';
import {getAmazonSites} from './amazonListingHelpers';
import {getCurrentState} from '../../shared/ActionsManager/EbayListingsActions/currentState';

export const AMAZON_STATUS_FILTER_ACTIVE = _.toString(AmazonListing.AmazonStatusFilterEnum.Active);
export const AMAZON_STATUS_FILTER_INACTIVE = _.toString(AmazonListing.AmazonStatusFilterEnum.Inactive);
export const STATUS_FILTERS = [AMAZON_STATUS_FILTER_ACTIVE, AMAZON_STATUS_FILTER_INACTIVE];

export const STATUS_FILTERS_TABS_PROPS: {[STATUS_FILTER_ACTIVE: string]: SubPageProps} = {
  [AMAZON_STATUS_FILTER_ACTIVE]: {
    title: AMAZON_STATUS_FILTER_ACTIVE,
    icon: <DoneIcon />,
  },
  [AMAZON_STATUS_FILTER_INACTIVE]: {
    title: AMAZON_STATUS_FILTER_INACTIVE,
    icon: <RemoveCircleOutlineIcon />,
  },
};

export const FIELD_NAMES = {
  // as defined by Amazon - some for reading and some for writing (hence the _/-)
  SKU: 'seller-sku',
  PRICE: 'price',
  QUANTITY: 'quantity',
  CONDITION_TYPE: 'condition_type',
  CONDITION_NOTE: 'condition_note',
  LISTING_ID: 'listing-id',
  SELLER_SKU: 'seller-sku',
  OPEN_DATE: 'open-date',
  ASIN: 'asin',
  PRODUCT_ID: 'product-id',
  STATUS: 'listing-status',
  SELLER_ID: 'sellerId',
  AMAZON_SITE: 'site',
  IMAGE_URL: 'image-url',
  FULFILLMENT_CHANNEL: 'fulfillment-channel',
  CL_PRODUCT_ID: 'productId',
  HANDLING_TIME: 'handling_time',
  VARIATIONS: 'Variations',
};

const SDK_ALLOWED_CONDITION_TYPES = [
  'New',
  'Refurbished',
  'Used Like New',
  'Used Very Good',
  'Used Good',
  'Used Acceptable',
];

export const DEFAULT_FIELD_PROPS = {
  [FIELD_NAMES.SKU]: {
    required: true,
    displayName: 'SKU',
    maxLength: 40,
    displayType: DISPLAY_TYPES.FREE_TEXT,
    type: 'shortString',
  },
  [FIELD_NAMES.PRICE]: {
    type: 'float',
    required: true,
    displayName: 'Price',
    displayType: DISPLAY_TYPES.FREE_TEXT,
    minValue: 0.01,
  },
  [FIELD_NAMES.ASIN]: {
    required: true,
    displayName: 'ASIN',
    displayType: DISPLAY_TYPES.FREE_TEXT,
    type: 'shortString',
    valueFormatter: '^\\w{10}$',
    formatErrorMessage: 'ASIN must be exactly 10 characters long.',
  },
  [FIELD_NAMES.QUANTITY]: {
    type: 'integer',
    required: true,
    displayName: 'Quantity',
    displayType: DISPLAY_TYPES.FREE_TEXT,
    minValue: 0,
  },
  [FIELD_NAMES.HANDLING_TIME]: {
    type: 'integer',
    displayName: 'Handling Time',
    displayType: DISPLAY_TYPES.FREE_TEXT,
    minValue: 0,
  },
  [FIELD_NAMES.CONDITION_TYPE]: {
    required: true,
    displayName: 'Condition',
    type: 'select',
    options: _.map(SDK_ALLOWED_CONDITION_TYPES, condition => ({
      value: condition.replace(new RegExp(' ', 'g'), ''),
      label: condition,
    })),
  },
  [FIELD_NAMES.CONDITION_NOTE]: {displayName: 'Condition Note', maxLength: 1000, displayType: DISPLAY_TYPES.FREE_TEXT},
  [FIELD_NAMES.FULFILLMENT_CHANNEL]: {
    displayName: 'Fulfilled By',
    options: [
      {value: 'DEFAULT', label: 'Merchant'},
      {value: 'AMAZON_NA', label: 'Amazon FBA'},
      {value: 'AMAZON_EU', label: 'Amazon FBA'},
      {value: 'AMAZON_JP', label: 'Amazon FBA'},
      {value: 'AMAZON_CN', label: 'Amazon FBA'},
      {value: 'AMAZON_IN', label: 'Amazon FBA'},
      {value: 'AMAZON_AU', label: 'Amazon FBA'},
    ],
  },
};

export const AMAZON_MAPPING = {
  [FIELD_NAMES.SKU]: {mappingType: MappingType.DirectMapping, name: 'SKU', displayName: 'SKU'},
  [FIELD_NAMES.PRICE]: {mappingType: MappingType.DirectMapping, name: 'Price', displayName: 'Price'},
  [FIELD_NAMES.ASIN]: {
    mappingType: MappingType.DirectMapping,
    name: 'ASIN',
    displayName: 'ASIN',
  },
  [FIELD_NAMES.QUANTITY]: {mappingType: MappingType.DirectMapping, name: 'Quantity', displayName: 'Quantity'},
  [FIELD_NAMES.CONDITION_NOTE]: {
    mappingType: MappingType.DirectMapping,
    name: 'ConditionNote',
    displayName: 'Condition Note',
  },
  [FIELD_NAMES.CONDITION_TYPE]: {mappingType: MappingType.ValueMapping, name: 'Condition', displayName: 'Condition'},
  [FIELD_NAMES.HANDLING_TIME]: {
    mappingType: MappingType.DirectMapping,
    name: 'HandlingTime',
    displayName: 'Handling Time',
  },
};

const getDomainFromSite = _.memoize(site => {
  return _.find(getAmazonSites(getCurrentState()), {text: site}).domain;
});

export const getAmazonListingIdHref = (asin, site, sellerId = null) => {
  const domain = getDomainFromSite(site);
  const seller = sellerId ? `/?seller=${sellerId}` : '';
  return `https://www.amazon.${domain}/gp/offer-listing/${asin}${seller}`;
};
